const TARGET_WIDTH = 384; // 58mm thermal printer @ 203 DPI
const BW_THRESHOLD = 128;
const CONTRAST_FACTOR = 1.5;

export function processImageForTicket(file: File): Promise<Blob> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    const url = URL.createObjectURL(file);

    img.onload = () => {
      URL.revokeObjectURL(url);

      const scale = TARGET_WIDTH / img.width;
      const width = TARGET_WIDTH;
      const height = Math.round(img.height * scale);

      const canvas = document.createElement("canvas");
      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext("2d")!;

      // Flatten transparency: fill white background first
      ctx.fillStyle = "#FFFFFF";
      ctx.fillRect(0, 0, width, height);

      // Draw resized image on top of white background
      ctx.drawImage(img, 0, 0, width, height);

      // Get pixel data
      const imageData = ctx.getImageData(0, 0, width, height);
      const data = imageData.data;

      // Convert to B&W: grayscale with luminosity formula, contrast boost, threshold
      for (let i = 0; i < data.length; i += 4) {
        const gray =
          0.299 * data[i] + 0.587 * data[i + 1] + 0.114 * data[i + 2];
        // Contrast boost: stretch toward extremes
        const boosted = Math.min(
          255,
          Math.max(0, (gray - 128) * CONTRAST_FACTOR + 128)
        );
        const bw = boosted > BW_THRESHOLD ? 255 : 0;
        data[i] = bw;
        data[i + 1] = bw;
        data[i + 2] = bw;
        data[i + 3] = 255; // Full opacity
      }

      ctx.putImageData(imageData, 0, 0);

      canvas.toBlob(
        (blob) => {
          if (blob) resolve(blob);
          else reject(new Error("Failed to create image blob"));
        },
        "image/png"
      );
    };

    img.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error("Failed to load image"));
    };

    img.src = url;
  });
}
